import * as React from 'react';
import { TransformFont } from '../../../components';
import './ThreeCouponsItem.less';
import { observer } from 'mobx-react';

interface IThreeCouponsItemPropsType {
    prefixCls?: string;
    data?: any;
    onHandleClick?: (data?: any) => void; // 点击领取事件
}

/**
 * 优惠券领取三列
 * @class ThreeCouponsItem
 * @extends {React.Component<IThreeCouponsItemPropsType, any>}
 */
@observer
class ThreeCouponsItem extends React.Component<IThreeCouponsItemPropsType, any> {
    static defaultProps = {
        prefixCls: 'three-coupons'
    };

    // 领取状态 1：可领取 2：已领取 3：已抢光
    private _showStatus(status: any): React.ReactNode {
        const {prefixCls, onHandleClick} = this.props;
        if (status === 1) {
            return (
                <div className={`${prefixCls}-btn`} onClick={() => {
                    onHandleClick && onHandleClick();
                }}>
                    点击领取
                </div>
            )
        } else if (status === 2) {
            return (
                <div className={`${prefixCls}-btn ${prefixCls}-btn-color`}>
                    已领取
                </div>
            )
        } else {
            return (
                <div className={`${prefixCls}-btn`}>
                    已抢光
                </div>
            )
        }
    }

    render(): React.ReactNode {
        const {prefixCls, data, onHandleClick} = this.props; // color
        return (
            <div className={`${prefixCls} ` + (data.receivedStatus === 3 ? `${prefixCls}-noUse` : ``)}>
                <div className={`${prefixCls}-context`} onClick={() => {
                    onHandleClick && data.receivedStatus === 1 && onHandleClick();
                }}>
                    <div className={`${prefixCls}-price`}>
                        <span className={`${prefixCls}-rmb`}>￥</span>
                        <TransformFont
                            font={data.couponMoney}
                            firstSize={'1.8rem'}
                            secondsSize={'1rem'}
                            class={`${prefixCls}-itemPrice-font`}
                        />
                    </div>
                    <div className={`${prefixCls}-msg`}>
                        <p>满￥{data.useLimit}可用</p>
                        <p>{data.couponName}</p>
                    </div>
                </div>
                {this._showStatus(data.receivedStatus)}
            </div>
        );
    }
}

export default ThreeCouponsItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/couponsItem/threeCouponsItem/ThreeCouponsItem.tsx